<template>
    <div class="percentLineBox">
        <div class="lineMainBox">
            <div class="lineBox" :data-id="this.domId" data-mark="test">
                <div class="line" :style="{width: lineLength}"></div>
                <div class="bageTipsBox" :style="{left: bageTipPosition}">
                    <div class="bageTips">
                        <div class="bageTipsText">
                            <p>{{bageText}}</p>
                            <p>{{unit}}</p>
                        </div>
                        <div class="beacon"
                            :class="{'beaconLeft': beaconType === 0, 'beaconNormal': beaconType === 1,'beaconRight': beaconType ===2}"
                            :style="{left: beaconType===0?beaconPosition:beaconType===2?beaconPosition:'50%'}"
                        ></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PercentLine',
        props: {
            pBageText: {
                type: [Number, String]
            },
            pPercent: {
                type: Number,
                required: true
            },
            pUnit: {
                type: String,
                default: ''
            },
            pId: {
                type: [Number, String],
                default: ''
            }
        },
        data () {
            return {
                // 传进来的Id
                id: '',
                // domID
                domId: 'lineBox',
                // 传进来的标签单位
                unit: '',
                // 传进来的标签Text
                bageText: '78',
                // 传进来的百分比
                percent: 0.55,
                // 进度条的总长度
                lineBoxLength: 0,
                // 进度条长度
                lineLength: 0,
                // 标签位置
                bageTipPosition: 0,
                // 标签宽度
                bageTipsBoxWidth: 0,
                // 标签活动范围(左)
                bageTipsBoxRangeLeft: 0,
                // 标签的活动范围(右)
                bageTipsBoxRangeRight: 0,
                // 标签指向标类型宽度
                beaconWidth: 0,
                // 标签指向标类型 (0左，1中，2右)
                beaconType: 0,
                // 标签指向标位置
                beaconPosition: 0
            }
        },
        created () {
            this.initData();
        },
        mounted () {
            this.getLineLength();
        },
        methods: {
            initData () {
                this.unit = this.pUnit;
                this.bageText = this.pBageText;
                this.percent = this.pPercent;
                this.id = this.pId;
            },
            getLineLength () {
                // this.domId = '[data-id=lineBox' + this.id + ']'
                this.domId = this.domId + this.id
                let elem = '[data-id=' + this.domId + ']'
                let t = setTimeout(() => {
                    // console.log('111111111111',this.domId,elem,document.querySelector('[data-mark=test]'))
                    // console.log('2222222222222222',this.domId,elem,document.querySelector(elem))
                    // this.lineBoxLength = 320;
                    this.lineBoxLength = document.querySelector(elem).offsetWidth;
                    this.lineLength = (this.lineBoxLength * (this.percent * 100)) / 100 + 'px'
                    this.bageTipsBoxWidth = document.querySelector(elem).children[1].offsetWidth;
                    this.bageTipsBoxRangeLeft = this.bageTipsBoxWidth / 2;
                    this.bageTipsBoxRangeRight = this.lineBoxLength - this.bageTipsBoxWidth
                    this.beaconWidth = document.querySelector(elem).children[1].children[0].children[1].offsetWidth;
                    if (parseFloat(this.lineLength) <= this.bageTipsBoxRangeLeft) {
                        this.bageTipPosition = '0px'
                        this.beaconType = 0;
                        if (parseFloat(this.lineLength) <= 2) {
                            this.beaconPosition = '2px'
                        } else {
                            this.beaconPosition = (parseFloat(this.lineLength) - 2) + 'px'
                        }
                    } else if (parseFloat(this.lineLength) >= this.bageTipsBoxRangeRight) {
                        this.bageTipPosition = (this.lineBoxLength - this.bageTipsBoxWidth) + 'px';
                        this.beaconType = 2
                        this.beaconPosition = ((this.bageTipsBoxWidth - this.beaconWidth - 2) - (this.lineBoxLength - parseFloat(this.lineLength))) + 'px';
                    } else {
                        this.bageTipPosition = (parseFloat(this.lineLength) - this.bageTipsBoxWidth / 2) + 'px'
                        this.beaconType = 1;
                    }
                    clearTimeout(t)
                }, 100)
                // this.lineBoxLength = document.querySelector(this.domId).offsetWidth;
                // console.log(this.domId,elem,document.querySelector('[data-mark=test]'))
                // console.log(this.domId,elem,document.querySelector('[data-id=lineBox0]'))
                // console.log(this.domId,elem,document.getElementsByClassName('percentLineBox'))
                // this.lineBoxLength = 320;
                // this.lineLength = (this.lineBoxLength * (this.percent * 100)) / 100 + 'px'
                // this.bageTipsBoxWidth = document.querySelector(this.domId).children[1].offsetWidth;
                // this.bageTipsBoxRangeLeft = this.bageTipsBoxWidth / 2;
                // this.bageTipsBoxRangeRight = this.lineBoxLength - this.bageTipsBoxWidth
                // this.beaconWidth = document.querySelector(this.domId).children[1].children[0].children[1].offsetWidth;
                // if (parseFloat(this.lineLength) <= this.bageTipsBoxRangeLeft) {
                //     this.bageTipPosition = '0px'
                //     this.beaconType = 0;
                //     if (parseFloat(this.lineLength) <= 2) {
                //         this.beaconPosition = '2px'
                //     } else {
                //         this.beaconPosition = (parseFloat(this.lineLength) - 2) + 'px'
                //     }
                // } else if (parseFloat(this.lineLength) >= this.bageTipsBoxRangeRight) {
                //     this.bageTipPosition = (this.lineBoxLength - this.bageTipsBoxWidth) + 'px';
                //     this.beaconType = 2
                //     this.beaconPosition = ((this.bageTipsBoxWidth - this.beaconWidth - 2) - (this.lineBoxLength - parseFloat(this.lineLength))) + 'px';
                // } else {
                //     this.bageTipPosition = (parseFloat(this.lineLength) - this.bageTipsBoxWidth / 2) + 'px'
                //     this.beaconType = 1;
                // }
            }
        }
    }
</script>

<style lang="less" scoped>
    .percentLineBox{
        margin: 0 1px;
        padding: 54px 0 0 0;
        box-sizing: border-box;

        div{
            box-sizing: border-box;
        }

        .lineMainBox{
            width: 100%;

            .lineBox{
                width: 100%;
                height: 6px;
                background-color: #E1EEE8;
                position: relative;

                .line{
                    width: 50%;
                    height: 100%;
                    background-color: #36B374;
                }

                .bageTipsBox{
                    background-color: rgba(0,0,0,.7);
                    border-radius: 3px;
                    position: absolute;
                    z-index: 1000;
                    // left: 0;
                    bottom: 18px;
                    // transform: translate(-50%,0);

                    .bageTips{
                        // width: 70px;
                        // height: 34px;
                        padding: 8px 12px;
                        position: relative;
                        .bageTipsText{
                            font-size: 20px;
                            font-weight: bold;
                            text-align: center;
                            color: #fff;
                            // position: relative;
                            display: flex;
                            >p:nth-child(1){
                                font-size: 20px;
                                font-weight: normal;
                            }
                            >p:nth-child(2){
                                font-size: 12px;
                                font-weight: normal;
                                margin-left: 4px;
                                margin-top: 5px;
                            }
                        }

                        .beaconNormal{
                            border: 5px solid #464646;
                            border-bottom-color: transparent;
                            border-left-color: transparent;
                            position: absolute;
                            z-index: 500;
                            bottom: -3px;
                            left: 49.8%;
                            transform: translate(-50%,0) rotate(135deg);
                            // transform: rotate(90deg);
                        }

                        .beaconLeft{
                            border: 4px solid #464646;
                            border-bottom-color: transparent;
                            border-left-color: transparent;
                            position: absolute;
                            z-index: 500;
                            bottom: -6.5px;
                            left: 2px;
                            transform: rotate(-90deg);
                            // transform: rotate(90deg);
                        }

                        .beaconRight{
                            border: 4px solid #464646;
                            border-bottom-color: transparent;
                            border-left-color: transparent;
                            position: absolute;
                            z-index: 500;
                            bottom: -7px;
                            left: 2px;
                            transform: rotate(-3deg);
                            // transform: rotate(90deg);
                        }
                    }
                }
            }
        }
    }
</style>
